// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1___a36d3c2090a67397696","cls2":"AutoCompleteResults-cls2___aef079eb85255a6188f AutoCompleteResults-cls1___a36d3c2090a67397696"};